import axios from "axios";
import config from "../../config";

const BASE_URL = `${config.url}/api/authors`

const AuthorManager = {
  // Get all authors
  async getAllAuthors() {
    const response = await axios.get(`${BASE_URL}/get`);
    return response.data;
  },

  // Get single author by ID
  async getAuthorById(id) {
    const response = await axios.get(`${BASE_URL}/get/${id}`);
    return response.data;
  },


    // Search authors by name
    async searchAuthorsByName(name) {
      const response = await axios.get(`${BASE_URL}/search?name=${name}`);
      return response.data;
    },

};

export default AuthorManager;
